<template>
  <Card>
    <div slot="body">
      <div class="d-flex justify-content-between align-items-start mb-4">
        <div>
          <h4 class="mb-1">ตรวจสอบที่อยู่</h4>
        </div>
        <Button
          type="button"
          :variant="summary && summary.invalid === 0 ? 'success' : 'warning'"
          size="sm"
          @click="$emit('proceed-to-create')"
        >
          ยืนยันและสร้างออเดอร์
        </Button>
      </div>

      <div class="mb-4">
        <div 
          v-for="(address, index) in processedAddresses" 
          :key="index"
          class="address-item mb-3"
          :class="address.processed.status"
        >
          <div class="d-flex justify-content-between align-items-center mb-2">
            <div class="font-weight-bold">
              📦 {{ address.orderId }} - {{ address.recipient }}
              <span 
                v-if="address.items && address.items.length > 1"
                class="badge badge-primary ml-2"
              >
                {{ address.items.length }} รายการ
              </span>
            </div>
        <span 
          class="badge"
          :class="{
            'badge-success': address.processed.status === 'valid',
            'badge-warning': address.processed.status === 'partial',
            'badge-danger': address.processed.status === 'invalid',
            'badge-info': address.processed.status === 'loading'
          }"
        >
          {{ getStatusText(address.processed.status) }}
        </span>
          </div>

          <div class="text-muted small mb-2">
            📍 ที่อยู่เดิม: {{ address.originalAddress }}
          </div>

          <div v-if="address.processed.status === 'loading'" class="alert alert-info">
            <i class="fal fa-spinner-third fa-spin mr-2"></i> กำลังประมวลผลที่อยู่...
          </div>

          <div v-if="address.processed.status !== 'loading'" class="row">
            <div class="col-md-3">
              <div class="border rounded p-2 mb-2 bg-light">
                <div class="small text-muted">รหัสไปรษณีย์</div>
                <div class="font-weight-bold">{{ address.processed.final.zipcode || 'N/A' }}</div>
              </div>
            </div>
            <div class="col-md-3">
              <div class="border rounded p-2 mb-2 bg-light">
                <div class="small text-muted">จังหวัด</div>
                <div class="font-weight-bold">{{ address.processed.final.province || 'N/A' }}</div>
              </div>
            </div>
            <div class="col-md-3">
              <div class="border rounded p-2 mb-2 bg-light">
                <div class="small text-muted">อำเภอ/เขต</div>
                <div class="font-weight-bold">{{ address.processed.final.district || 'N/A' }}</div>
              </div>
            </div>
            <div class="col-md-3">
              <div class="border rounded p-2 mb-2 bg-light">
                <div class="small text-muted">ตำบล/แขวง</div>
                <div class="font-weight-bold">{{ address.processed.final.subdistrict || 'N/A' }}</div>
              </div>
            </div>
          </div>

          <div v-if="address.items && address.items.length > 0" class="alert alert-info mt-2">
            <div class="font-weight-bold mb-1">
              🛒 สินค้าในออเดอร์ ({{ address.items.length }} รายการ, น้ำหนักรวม {{ (address.totalWeightGrams / 1000).toFixed(2) }} kg)
            </div>
            <ul class="mb-0 pl-3">
              <li v-for="(item, idx) in address.items" :key="idx">
                {{ item.name }} x{{ item.qty }} ({{ item.weightKg }}kg)
              </li>
            </ul>
          </div>
        </div>
      </div>

      <div class="alert alert-info" v-if="summary">
        📊 สรุป: ถูกต้อง {{ summary.valid }}, บางส่วน {{ summary.partial }}, ผิด {{ summary.invalid }} จากทั้งหมด {{ summary.total }} รายการ
      </div>

      <div class="text-center">
        <Button
          type="button"
          :variant="summary && summary.invalid === 0 ? 'success' : 'warning'"
          size="lg"
          @click="$emit('proceed-to-create')"
        >
          ยืนยันและสร้างออเดอร์
        </Button>
      </div>
    </div>
  </Card>
</template>

<script>
import Card from "@/components/core/Card";
import Button from "@/components/core/Button";

export default {
  name: "AddressValidationScreen",
  components: { Card, Button },
  props: {
    processedAddresses: {
      type: Array,
      default: () => []
    }
  },
  computed: {
    summary() {
      if (!this.processedAddresses || this.processedAddresses.length === 0) return null;
      
      return {
        valid: this.processedAddresses.filter(a => a.processed.status === 'valid').length,
        partial: this.processedAddresses.filter(a => a.processed.status === 'partial').length,
        invalid: this.processedAddresses.filter(a => a.processed.status === 'invalid').length,
        total: this.processedAddresses.length
      };
    }
  },
  methods: {
    getStatusText(status) {
      const statusMap = {
        'loading': '⏳ กำลังประมวลผล',
        'valid': '✅ ถูกต้อง',
        'partial': '⚠️ บางส่วน',
        'invalid': '❌ ไม่ถูกต้อง'
      };
      return statusMap[status] || status;
    }
  }
};
</script>

<style lang="scss" scoped>
.address-item {
  border: 1px solid #e2e8f0;
  border-radius: 10px;
  padding: 15px;
  background: white;

  &.valid {
    border-color: #9ae6b4;
    background: #f0fff4;
  }

  &.partial {
    border-color: #f6e05e;
    background: #fffbf0;
  }

  &.invalid {
    border-color: #feb2b2;
    background: #fed7d7;
  }
}
</style>
